import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectArquivos } from '../../app/slices/arquivosSlice';
import { fecharModalArquivo } from '../../app/slices/modalSlice';
import { ContainerJanela, Divisor } from '../../styles/base';
import Botao from '../Botao/Botao';
import { JanelaArquivo } from './VisualizadorArquivosEstilo';

const VisualizadorArquivos = () => {
  const dispatch = useDispatch();

  const dadosArquivos = useSelector(selectArquivos);

  if (dadosArquivos.data && dadosArquivos.data.type.startsWith('audio')) {
    return (
      <ContainerJanela>
        <JanelaArquivo>
          <div style={{ alignSelf: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalArquivo())}
            />
          </div>

          <Divisor />

          <audio controls>
            <source src={dadosArquivos.data.preview} />
            <track default kind="captions" />
          </audio>
        </JanelaArquivo>
      </ContainerJanela>
    );
  }

  if (dadosArquivos.data && dadosArquivos.data.type.startsWith('video')) {
    return (
      <ContainerJanela>
        <JanelaArquivo>
          <div style={{ alignSelf: 'flex-end ' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalArquivo())}
            />
          </div>

          <Divisor />

          <video controls>
            <source src={dadosArquivos.data.preview} />
            <track default kind="captions" />
          </video>
        </JanelaArquivo>
      </ContainerJanela>
    );
  }

  if (dadosArquivos.data && dadosArquivos.data.type === 'application/pdf') {
    return (
      <ContainerJanela>
        <JanelaArquivo>
          <div style={{ alignSelf: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalArquivo())}
            />
          </div>

          <Divisor />

          <iframe
            title="PDF selecionado"
            width="1200"
            height="800"
            frameBorder="0"
            src={dadosArquivos.data.preview}
          />
        </JanelaArquivo>
      </ContainerJanela>

    );
  }

  return (
    <ContainerJanela>
      <JanelaArquivo>
        <div style={{ alignSelf: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalArquivo())}
          />
        </div>

        <Divisor />

        {dadosArquivos.data && (<img src={dadosArquivos.data.preview} alt="Imagem selecionada" />)}
      </JanelaArquivo>
    </ContainerJanela>
  );
};

export default VisualizadorArquivos;
